<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Incomes')"
          :description="$t('From here you can control the incomes')"
        />
        <indexTable
          :searchText="$t('Search for allowance')"
          :emptyTableText="$t('There are no incomes')"
          :buttonRole="$checkRole('expenses_add')"
          :statusSearch="true"
          :statusValues="[
            { title: $t('Situation'), value: '' },
            { title: $t('All'), value: '' },
            { title: $t('Draft'), value: 0 },
            { title: $t('Approved'), value: 1 }
          ]"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :cloumns="[
            {
              column: 'code',
              title: $t('PerDiem'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'safe_id',
              title: $t('Treasury'),
              type: 'link',
              to: 'safe',
              sort: true,
              link: true
            },
            {
              column: 'date',
              title: $t('Income date'),
              type: 'text',
              sort: true
            },
            {
              column: 'income_section_id',
              title: $t('Section'),
              type: 'link',
              to: 'incomeSection',
              sort: true,
              link: false
            },
            {
              column: 'description',
              title: $t('Thats about'),
              type: 'text',
              sort: true
            },
            {
              column: 'notes',
              title: $t('Note'),
              type: 'text',
              sort: true
            },
            {
              column: 'cost',
              title: $t('Amount'),
              type: 'text',
              sort: true
            },
            {
              column: 'type',
              title: $t('Type'),
              type: 'status',
              sort: true,
              values: [
                { title: $t('Paid'), value: 0, color: 'success' },
                { title: $t('Worthy'), value: 1, color: 'dark' }
              ]
            },
            {
              column: 'user_name',
              title: $t('Responsible name'),
              type: 'text',
              sort: true
            },
            {
              column: 'status',
              title: $t('Situation'),
              type: 'status',
              sort: true,
              values: [
                { title: $t('Draft'), value: 0, color: 'dark' },
                { title: $t('Approved'), value: 1, color: 'success' }
              ]
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'show' },
                { name: 'edit', role: $checkRole('expenses_edit') },
                { name: 'file' },
                { name: 'printIncome', role: true },
                { name: 'download', role: true },
                {
                  name: 'delete',
                  role: $checkRole('expenses_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/incomes'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
